module.exports = __webpack_public_path__ + "img/animals_07_H.68b26ed3.webp";